import React from 'react';
import { Modal } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { SearchIcon } from './mdPageIcons';
import './LookupModal.css';

export function LookupActionHeader() {
  return <th scope="col" className="md-lookup__col-action" aria-label="Seleccionar" />;
}

export function LookupSelectButton({ onClick, testId }) {
  return (
    <td className="md-lookup__col-action">
      <button
        type="button"
        className="md-lookup__select-btn"
        onClick={onClick}
        data-testid={testId}
      >
        Seleccionar
      </button>
    </td>
  );
}

export function LookupModal({
  show,
  onHide,
  title,
  searchInputRef,
  searchInput,
  searchPlaceholder,
  onSearchInputChange,
  onSearchSubmit,
  loading,
  errorMessage,
  pageCount,
  forcePage,
  onPageChange,
  children,
  size = 'lg',
  dialogClassName = 'md-lookup__dialog',
}) {
  const controlsDisabled = loading;

  return (
    <Modal
      className="md-lookup"
      dialogClassName={dialogClassName}
      contentClassName="md-lookup__content"
      size={size}
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header className="md-lookup__header">
        <Modal.Title className="md-lookup__title" as="h2">
          {title}
        </Modal.Title>
        <button
          type="button"
          className="md-lookup__close"
          onClick={onHide}
          aria-label="Cerrar"
        >
          ×
        </button>
      </Modal.Header>
      <Modal.Body className="md-lookup__body">
        {errorMessage ? (
          <div className="md-lookup__error" role="alert">{errorMessage}</div>
        ) : null}
        <form className="md-lookup__search-row" onSubmit={onSearchSubmit}>
          <div className="md-lookup__search-wrap">
            <span className="md-lookup__search-icon" aria-hidden="true">
              <SearchIcon />
            </span>
            <input
              ref={searchInputRef}
              className="md-lookup__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={controlsDisabled}
              placeholder={searchPlaceholder}
              value={searchInput}
              onChange={onSearchInputChange}
            />
          </div>
          <button type="submit" className="md-lookup__search-btn" disabled={controlsDisabled}>
            Buscar
          </button>
        </form>
        {loading ? (
          <p className="md-lookup__loading"><em>Cargando datos...</em></p>
        ) : (
          <div className="md-lookup__table-card">{children}</div>
        )}
        {!loading && pageCount > 1 ? (
          <div className="md-lookup__pagination md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={onPageChange}
              forcePage={forcePage}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}
